import React from 'react';
import { motion } from 'framer-motion';

const AboutSection: React.FC = () => {
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const aboutData = [
    {
      icon: '🌟',
      title: 'My Favorite Things',
      items: [
        '🎨 Drawing and painting',
        '📚 Reading magical stories',
        '🎵 Dancing to happy music',
        '🧸 Playing with my toys',
      ]
    },
    {
      icon: '🎯',
      title: 'My Dreams',
      items: [
        '🚀 Become an astronaut',
        '🎭 Perform on stage',
        '🦄 Meet a real unicorn',
        '🌍 Travel around the world'
      ]
    },
    {
      icon: '💝',
      title: 'What Makes Me Happy',
      items: [
        '👨‍👩‍👧 Time with family',
        '🎪 Fun adventures',
        '🍦 Ice cream treats',
        '🐱 Cute animals'
      ]
    }
  ];

  return (
    <section className="about" id="about">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          About Beautiful Krisha
        </motion.h2>

        <motion.div
          className="about-cards"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {aboutData.map((card, index) => (
            <motion.div
              key={index}
              className="about-card"
              variants={cardVariants}
              whileHover={{ 
                y: -10, 
                scale: 1.02,
                transition: { duration: 0.3 }
              }}
            >
              <motion.div
                className="card-icon bounce"
                whileHover={{ scale: 1.2, rotate: 10 }}
                transition={{ duration: 0.3 }}
              >
                {card.icon}
              </motion.div>
              <h3>{card.title}</h3>
              <ul>
                {card.items.map((item, itemIndex) => (
                  <motion.li
                    key={itemIndex}
                    whileHover={{ x: 10, color: '#ff6b9d' }}
                    transition={{ duration: 0.2 }}
                  >
                    {item}
                  </motion.li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
